import { combineReducers } from 'redux';

import filters from './filters';
import authentication from './authentication';
import dao from './dao';
import search from './search';
import ui from './ui';
import tnc from './tnc';
import sam from './sam';

const rootReducer = combineReducers({
  filters,
  authentication,
  dao,
  search,
  ui,
  tnc,
  sam,
});

export default rootReducer;
